<scitis-breadcrumb [breadcrumbRoutes]="routes"></scitis-breadcrumb>
<scitis-app-global-page-header>
  <div header-title>
    <scitis-page-header-logo-and-name
        [machineCategory]="pageGlobalParameters.machineCategory"
        [machineId]="pageGlobalParameters.machineId"
        [machineMenuItem]="pageGlobalParameters.associatedMenuItem.menuItemParent"
        [pageName]="pageGlobalParameters.pageName|translate"
        [pageType]="pageGlobalParameters.pageType">

    </scitis-page-header-logo-and-name>
  </div>

  <ng-template #filterElement>
    <div>
      <button class="btn btn-outline-primary" (click)="onCollapseSettingsChange()">
        <span class="fa-solid fa-sliders"></span>
        <span *ngIf="isCollapsed" translate>Show settings</span>
        <span *ngIf="!isCollapsed" translate>Hide settings</span>
      </button>
    </div>
  </ng-template>
  <ng-template #filterElement>
    <scitis-interactive-data-analysis-actions [isHigherThanAdmin]="isHigherThanAdmin"
                                              [machineId]="pageGlobalParameters.machineId"
                                              [useColorPalette]="useColorPalette"
                                              (toggleUseColorPalette)="onToggleUseColorPalette()"
                                              (chartDataExportTriggered)="onChartDataExportTriggered($event)"
                                              (interactiveDataAnalysisConfig)="onInteractiveDataAnalysisConfigUpdated($event)">
    </scitis-interactive-data-analysis-actions>
  </ng-template>
</scitis-app-global-page-header>

<div class="page-content">
  <scitis-interactive-data-analysis
      [machineId]="pageGlobalParameters.machineId"
      [organizationId]="pageGlobalParameters.organizationId"
      [name]="pageGlobalParameters.pageName"
      [exportStarted]="exportStartedWithType"
      [useColorPalette]="useColorPalette"
      [isCollapsed]="isCollapsed"
      [updatedInteractiveDataAnalysisConfig]="updatedInteractiveDataAnalysisConfig"
      [widgetInformation]="pageGlobalParameters.widgetInformation">
  </scitis-interactive-data-analysis>
</div>
